import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Layout } from './components/Layout';
import Home from './pages/Home';
// import { ServicesPage } from './pages/ServicesPage'; // 🔒 Next version
// import { PhotoboothPage } from './pages/PhotoboothPage'; // 🔒 Next version
// import { ProductionPage } from './pages/ProductionPage'; // 🔒 Next version
import { PortfolioPage } from './pages/PortfolioPage';
import QuoteViewPage from './pages/QuoteViewPage';
import { ContactPage } from './pages/ContactPage';
import { ServiceSeoPage } from './pages/ServiceSeoPage';
import { PortfolioSeoPage } from './pages/PortfolioSeoPage';
import DashboardPage from './pages/DashboardPage';
import ProjectPage from './pages/ProjectPage';
import TransferPage from './pages/TransferPage'; // Import TransferPage
import { AboutPage } from './pages/AboutPage';
import { FAQPage } from './pages/FAQPage';
import { BlogPage } from './pages/BlogPage';
import { BlogArticlePage } from './pages/BlogArticlePage';
import RequireAuth from './components/RequireAuth';
import { AuthProvider } from './context';
import { NotFoundPage } from './pages/NotFoundPage';
import { ScrollToTop } from './components/ScrollToTop';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="transfer/:token" element={<TransferPage />} />

              <Route path="services" element={<ServiceSeoPage />} />
              <Route path="mariage" element={<ServiceSeoPage />} />
              <Route path="photobooth" element={<ServiceSeoPage />} />
              <Route path="production" element={<ServiceSeoPage />} />
              <Route path="photographe-mariage-djerba" element={<ServiceSeoPage />} />
              <Route path="photographe-evenement-tunis" element={<ServiceSeoPage />} />
              <Route path="photobooth-djerba" element={<ServiceSeoPage />} />
              <Route path="video-corporate-tunisie" element={<ServiceSeoPage />} />
              <Route path="photobooth-tunisie" element={<ServiceSeoPage />} />
              <Route path="portfolio/mariage" element={<PortfolioSeoPage />} />
              <Route path="portfolio/photobooth" element={<PortfolioSeoPage />} />
              <Route path="portfolio/corporate" element={<PortfolioSeoPage />} />
              <Route path="portfolio/shooting" element={<PortfolioSeoPage />} />
              <Route path="portfolio" element={<PortfolioPage />} />
              <Route path="blog" element={<BlogPage />} />
              <Route path="blog/:slug" element={<BlogArticlePage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="faq" element={<FAQPage />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="projects/:slug" element={<ProjectPage />} />
              <Route path="quotes/:quoteNumber" element={<QuoteViewPage />} />

              {/* Protected Routes */}
              <Route element={<RequireAuth />}>
                <Route path="dashboard" element={<DashboardPage />} />
              </Route>
              {/* 404 */}
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;

